import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/i18n";
import Seo from "@/components/Seo";
import { ATTRACTIONS } from "@/data/attractions";
import { orgSchema, breadcrumb } from "@/lib/seo";
import { ArrowRight } from "@phosphor-icons/react";

export default function Attractions() {
  const { t, lang } = useI18n();
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14" data-testid="attractions-page">
      <Seo title={t("seo_attractions_title")}
        description={t("attractions_sub")} path="/ausfluege"
        jsonLd={[orgSchema(), breadcrumb([{ name: "Home", path: "/" }, { name: t("nav_attractions"), path: "/ausfluege" }])]} />
      <p className="font-body text-sm text-[#EF5A1E] font-semibold mb-3">{t("nav_attractions")}</p>
      <h1 className="font-heading font-bold tracking-tight text-4xl sm:text-5xl text-[#0B1533] leading-[1.05] max-w-3xl">{t("attractions_title")}</h1>
      <p className="font-body text-[#5A607A] mt-5 text-lg max-w-2xl">{t("attractions_sub")}</p>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-10">
        {ATTRACTIONS.map((a) => {
          const c = a[lang] || a.de;
          return (
            <Link key={a.slug} to={`/ausfluege/${a.slug}`} data-testid={`attraction-${a.slug}`}
              className="group rounded-2xl border border-[#E9E5DE] bg-white p-6 hover:border-[#EF5A1E] transition-colors duration-200 flex flex-col">
              <span className="font-body text-xs font-semibold text-[#EF5A1E]">{a.region}</span>
              <h2 className="font-heading font-bold text-xl tracking-tight text-[#0B1533] mt-2">{c.name}</h2>
              <p className="font-body text-sm text-[#5A607A] mt-2 leading-relaxed flex-1">{c.intro}</p>
              <span className="inline-flex items-center gap-1.5 font-body text-sm font-semibold text-[#0B1533] mt-4 group-hover:text-[#EF5A1E] transition-colors">{t("dest_book_now")} <ArrowRight size={15} className="group-hover:translate-x-1 transition-transform" /></span>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
